import AppServiceNewApi from "./AppServiceNewApi";

class FileService extends AppServiceNewApi{
    constructor() {
        super();
        this.path = '/api/internal/v1/files';
    }

    getFiles(params) {
        const pagination = params.pagination;
        const filters = params.filters;
        let filterString = '&'
        if(filters?.category)filterString = `${filterString}CategoryId=${filters?.category}&`
        if(filters?.createdAt)filterString = `${filterString}CreatedAt=${filters?.createdAt}&`
        if(filters?.errorStatus !== null && filters?.errorStatus !== undefined)filterString = `${filterString}HasError=${filters?.errorStatus}&`
        if(filterString === '&')filterString = ''
        else filterString = filterString.substring(0, filterString?.length - 1)

        const url = `${this.path}?PageNumber=${pagination?.page}&PageSize=${pagination?.size}${filterString}`;
        return this.http.get(url);
    }

    getCategories(){
        return this.http.get(`${this.path}/categories`);
    }
}
export default  FileService;